import { useEffect } from "react";
import { css } from "@emotion/react";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { fadeInVariants } from "../../constants/animations";
import { useGetMediaSize } from "../../hooks";

const Character = () => {
  const { width } = useGetMediaSize({});

  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView]);

  return (
    <div css={mainStyle} id="trailer">
      <div css={containerStyle}>
        <motion.div
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={fadeInVariants}
        >
          <div css={titleStyle}>CHARACTER</div>
          <div css={imgWrapperStyle}>
            <img
              css={imgStyle(width)}
              src={
                process.env.REACT_APP_BASE_PATH + "/img/ks_soukanzu_240422.png"
              }
              alt="character"
              id="character"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  background-size: cover;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/bg-character.jpeg"});
  background-position: center;
  background-size: cover;
`;

const containerStyle = css`
  width: 100%;
  padding: 40px 0 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(41, 73, 91, 0.32);

  @media (max-width: ${spSize}px) {
    padding: 30px 0 40px;
  }
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
  }
`;

const imgWrapperStyle = css`
  width: 100%;
  padding-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding-top: 30px;
  }
`;

const imgStyle = (width: number) => css`
  width: ${width}px;
  height: auto;
`;

export default Character;
